import Skeleton from '@mui/material/Skeleton';
import Grid from '@mui/material/GridLegacy';

const RecruitmentPageTabSkeleton = () => (
	<Grid
		container
		rowSpacing={2}
		pt={3}
		role='progressbar'
		aria-label='Loading'
	>
		<Grid item xs={12}>
			<Skeleton variant='rectangle' width='100%' height='56px' />
		</Grid>
		<Grid item xs={12}>
			<Skeleton variant='rectangle' width='100%' height='24px' />
		</Grid>
		<Grid item xs={12}>
			<Skeleton variant='rectangle' width='100%' height='48px' />
		</Grid>
		<Grid item xs={12}>
			<Skeleton variant='rectangle' width='100%' height='24px' />
		</Grid>
		<Grid item xs={12}>
			<Skeleton variant='rectangle' width='100%' height='24px' />
		</Grid>
	</Grid>
);

export default RecruitmentPageTabSkeleton;
